import { AvgCostConversion, MinTaxConversion } from '@interfaces/models/spec-id-fallback.enum';
import { createAction, props } from '@ngrx/store';
import { AccountTypes, TransactionTypesEnum } from '@shared/models';
import { CostBasisPosition } from '@store/reducers/cost-basis/cost-basis.reducer';

import {
  InternalTransferMethodEnum,
  InternalTransferState,
  InternalTransferTriage,
  InternalTransferTypeEnum,
} from '../../reducers/internal-transfer/internal-transfer.reducer';

export const ClearInternalTransferState = createAction(
  '[Internal Transfer] Triage: Clear existing internal transfer state',
);

export const ClearTransferToSelectedAccount = createAction(
  '[Internal Transfer] Clear internal transfer transferring to selected account state',
);

export const UpdateInternalTransferTriage = createAction(
  '[Internal Transfer] Update Triage Status Selection',
  props<{ payload: InternalTransferTriage }>(),
);

export const UpdateInternalTransferTriageTransferFrom = createAction(
  '[Internal Transfer] Update Triage Transfer From Selection',
  props<{ payload: AccountTypes }>(),
);

export const UpdateInternalTransferTriageTransferTo = createAction(
  '[Internal Transfer] Update Triage Transfer To Selection',
  props<{ payload: AccountTypes }>(),
);

export const UpdateInternalTransferTriageIsOwner = createAction(
  '[Internal Transfer] Update Triage IsOwner Selection',
  props<{ payload: boolean }>(),
);

export const UpdateInternalTransferTriageExceptionsApply = createAction(
  '[Internal Transfer] Update Triage ExceptionsApply Selection',
  props<{ payload: boolean }>(),
);

export const UpdateInternalTransferTriageDivorceTransfer = createAction(
  '[Internal Transfer] Update Triage Divorce Transfer Selection',
  props<{ payload: boolean }>(),
);

export const UpdateInternalTransferTriageIsGift = createAction(
  '[Internal Transfer] Update Triage IsGift Selection',
  props<{ payload: boolean }>(),
);

export const UpdateInternalTransferTriageOrgToOrg = createAction(
  '[Internal Transfer] Update Triage Org To Org Selection',
  props<{ payload: { isOwner: boolean } }>(),
);

export const UpdateInternalTransferTransferFrom = createAction(
  '[Internal Transfer] Update Account From Status Selection',
  props<{ payload: InternalTransferState['transferFrom'] }>(),
);

export const UpdateInternalTransferFromAccount = createAction(
  '[Internal Transfer] Update Account From Selection',
  props<{ payload: InternalTransferState['transferFrom']['selectedAccount'] }>(),
);

export const UpdateInternalTransferPercentageOfHoldings = createAction(
  '[Internal Transfer] Update Percentage Of Selected Positions',
  props<{ payload: string }>(),
);

export const UpdateInternalTransferSelectedAccountTo = createAction(
  '[Internal Transfer] Update Account To Status Selection',
  props<{ payload: InternalTransferState['transferTo'] }>(),
);

export const UpdateInternalTransferTransactionType = createAction(
  '[Internal Transfer] Update Transaction Type',
  props<{ payload: TransactionTypesEnum }>(),
);

export const UpdateInternalTransferId = createAction(
  '[Internal Transfer] Update Transfer ID',
  props<{ payload: string }>(),
);

export const UpdateInternalTransferSignerState = createAction(
  '[Internal Transfer] Update Internal Transfer Signer State for Additional Signer',
  props<{ payload: string }>(),
);

export const UpdateInternalTransferConvertSpecIDHoldings = createAction(
  '[Internal Transfer] Update Convert Spec ID Holdings',
  props<{ payload: boolean }>(),
);

export const UpdateInternalTransferConvertAvgCostHoldings = createAction(
  '[Internal Transfer] Update Convert Average Cost Holdings',
  props<{ payload: boolean }>(),
);

export const UpdateInternalTransferHasAvgCostHoldings = createAction(
  '[Internal Transfer] Update Has Avg Cost Holdings',
  props<{ payload: boolean }>(),
);

export const UpdateInternalTransferTransferMethod = createAction(
  '[Internal Transfer] Update Transfer Method',
  props<{ payload: InternalTransferMethodEnum }>(),
);

export const UpdateInternalTransferTransferType = createAction(
  '[Internal Transfer] Update Transfer Type',
  props<{ payload: InternalTransferTypeEnum }>(),
);

export const UpdateInternalTransferTransferAllSelected = createAction(
  '[Internal Transfer] Update Transfer All Selected',
  props<{ payload: boolean }>(),
);

export const UpdateInternalTransferTotalTransferValue = createAction(
  '[Internal Transfer] Update Total Transfer Value',
  props<{ payload: string }>(),
);

export const InternalTransferSummaryContinue = createAction(
  '[Internal Transfer Summary Continue] Internal Transfer Summary: Continue',
);

export const LoadInternalTransferCalculations = createAction(
  '[Internal Transfer] Starting Internal Transfer Calculations',
);
export const LoadInternalTransferCalculationsSuccess = createAction(
  '[Internal Transfer] Starting Internal Transfer Calculations Success',
);

export const CalculateSharesToTransfer = createAction(
  '[Internal Transfer] Starting Calculation for Shares To Be Transferred',
);
export const CalculateSharesToTransferSuccess = createAction(
  '[Internal Transfer] Starting Calculation for Shares To Be Transferred Success',
);
export const CalculateSharesToTransferFail = createAction(
  '[Internal Transfer] Calculation for Shares To Be Transferred Fail',
);

export const CalculateEstimatedValueOfTransfer = createAction(
  '[Internal Transfer] Starting Calculation for Estimated Value Of Transfer for Holding',
  props<{ payload: CostBasisPosition[] }>(),
);
export const CalculateEstimatedValueOfTransferSuccess = createAction(
  '[Internal Transfer] Starting Calculation for Estimated Value Of Transfer for Holding Success',
);
export const CalculateEstimatedValueOfTransferFail = createAction(
  '[Internal Transfer] Calculation for Estimated Value Of Transfer for Holding Fail',
);

export const CalculateTotalEstimatedAmount = createAction(
  '[Internal Transfer] Starting Calculation for Total Estimated Amount',
  props<{ payload: CostBasisPosition[] }>(),
);
export const CalculateTotalEstimatedAmountFail = createAction(
  '[Internal Transfer] Calculation for Total Estimation To Be Transferred Fail',
);

export const UpdateInternalTransferAvgCostConversion = createAction(
  '[Internal Transfer] Update Average Cost Conversion',
  props<{ payload: AvgCostConversion }>(),
);

export const UpdateInternalTransferMinTaxConversion = createAction(
  '[Internal Transfer] Update MinTax Conversion',
  props<{ payload: MinTaxConversion }>(),
);

export interface HydrateInternalTransferFromMultiITPayload {
  fromAccount: InternalTransferState['transferFrom']['selectedAccount'];
  transferMethod: InternalTransferMethodEnum;
  transferType: InternalTransferTypeEnum;
  avgCostConversion: AvgCostConversion;
  minTaxConversion: MinTaxConversion;
  convertAvgCostHoldings: boolean;
  convertSpecIDHoldings: boolean;
  transferTo: InternalTransferState['transferTo'];
  transactionType: TransactionTypesEnum;
  percentageOfHoldings: string;
  totalTransferValue: string;
  selectedPositions: CostBasisPosition[];
}

export const HydrateDivorceFromMultiIT = createAction(
  '[Internal Transfer] Hydrate From Multi Internal Transfer For Divorce',
  props<{ payload: HydrateInternalTransferFromMultiITPayload }>(),
);

export const HydrateOrgToOrgFromMultiIT = createAction(
  '[Internal Transfer] Hydrate From Multi Internal Transfer For Org To Org',
  props<{ payload: HydrateInternalTransferFromMultiITPayload }>(),
);
